import React, { useEffect, useState } from 'react';
import { generateLotMappingReport } from '../debug-lot-mapping';

interface LotMappingData {
  geoJsonId: string;
  geoJsonHolder: string;
  databaseId: string;
  databaseAvail: string;
  matchStatus: string;
}

/**
 * Component to display lot mapping debug information.
 * This is a temporary component for debugging purposes only.
 */
const DebugLotMapping: React.FC = () => {
  const [mappingData, setMappingData] = useState<LotMappingData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadMappingData = async () => {
      try {
        setLoading(true);
        const data = await generateLotMappingReport();
        setMappingData(data || []);
      } catch (err) {
        console.error('Error loading mapping data:', err);
        setError('Failed to load mapping data. Check console for details.');
      } finally {
        setLoading(false);
      }
    };

    loadMappingData();
  }, []);

  if (loading) {
    return <div className="p-4">Loading lot mapping data...</div>;
  }

  if (error) {
    return <div className="p-4 text-red-600">{error}</div>;
  }

  if (!mappingData.length) {
    return <div className="p-4">No mapping data found.</div>;
  }

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Lot Mapping Debug Information</h2>
      <p className="mb-4">Showing mapping between GeoJSON and database records for specific lots.</p>
      
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="p-2 border">GeoJSON ID</th>
              <th className="p-2 border">GeoJSON Holder</th>
              <th className="p-2 border">Database ID</th>
              <th className="p-2 border">Database Availability</th>
              <th className="p-2 border">Match Status</th>
            </tr>
          </thead>
          <tbody>
            {mappingData.map((item, index) => (
              <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : ''}>
                <td className="p-2 border">{item.geoJsonId}</td>
                <td className="p-2 border">{item.geoJsonHolder}</td>
                <td className="p-2 border">{item.databaseId}</td>
                <td className="p-2 border">
                  <span 
                    className={
                      item.databaseAvail === 'Y' ? 'text-green-600 font-semibold' : 
                      item.databaseAvail === 'N' ? 'text-red-600 font-semibold' : 
                      'text-gray-500'
                    }
                  >
                    {item.databaseAvail}
                  </span>
                </td>
                <td className="p-2 border">
                  <span 
                    className={
                      item.matchStatus === 'EXACT MATCH' ? 'text-green-600' : 
                      item.matchStatus === 'CASE-INSENSITIVE MATCH' ? 'text-yellow-600' : 
                      'text-red-600'
                    }
                  >
                    {item.matchStatus}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DebugLotMapping;
